<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<wa-button [routerLink]="['/plugins']" appearance="plain" variant="neutral">Back to Plugins</wa-button>
		<wa-card appearance="outlined">
			<div class="wa-stack wa-gap-m">
				<div class="wa-stack wa-gap-s">
					<h1 waHeading="xl" waText>FullCalendar</h1>
					<p waBody="m" waText>Full-featured calendar &#40;FullCalendar 6.1.19&#41; &mdash; drag-and-drop scheduling, multiple views, timezone support, and server-driven event management with Angular integration. Supports DayGrid, TimeGrid, List views, recurring events, localization for 50+ locales, and Bootstrap 5 theming.</p>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25+</wa-tag>
						<wa-tag pill variant="neutral">FullCalendar 6.1.19</wa-tag>
						<wa-tag pill variant="neutral">Angular 21</wa-tag>
						<wa-tag pill variant="neutral">TypeScript 5</wa-tag>
						<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>COORDINATES &amp; MODULE</div>
					<p waBody="s" waText>Maven: com.jwebmp.plugins:fullcalendar</p>
					<p waBody="s" waText>JPMS Module: com.jwebmp.plugins.fullcalendar</p>
					<p waBody="s" waText>Built on: FullCalendar 6.1.19</p>
				</div>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>INSTALLATION</div>
					<div class="code-block-wrapper">
						<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Maven</div>
						<markdown [data]="mdContent_104" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
					</div>
					<div class="code-block-wrapper">
						<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Gradle &#40;Kotlin DSL&#41;</div>
						<markdown [data]="mdContent_105" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
					</div>
				</div>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>NPM DEPENDENCIES &#40;auto-included&#41;</div>
					<markdown [data]="mdContent_106" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>FEATURES</div>
					<p waBody="s" waColorText="quiet" waText>Full calendar views &mdash; Day, Week, Month, List, and custom views</p>
					<p waBody="s" waColorText="quiet" waText>Drag and drop events &mdash; interactive event creation, editing, and rescheduling</p>
					<p waBody="s" waColorText="quiet" waText>Multiple calendar types &mdash; DayGrid, TimeGrid, List</p>
					<p waBody="s" waColorText="quiet" waText>Full IANA timezone support via Moment Timezone</p>
					<p waBody="s" waColorText="quiet" waText>Localization &mdash; multi-language support with 50+ locales</p>
					<p waBody="s" waColorText="quiet" waText>Event sources &mdash; JSON feeds, functions, Google Calendar integration</p>
					<p waBody="s" waColorText="quiet" waText>Recurring events with RRule support</p>
					<p waBody="s" waColorText="quiet" waText>Bootstrap 5 theme integration</p>
					<p waBody="s" waColorText="quiet" waText>Mobile adaptive &mdash; responsive design with touch support</p>
					<p waBody="s" waColorText="quiet" waText>Type-safe Java API &mdash; CRTP fluent API for calendar configuration</p>
					<p waBody="s" waColorText="quiet" waText>Server-driven config &mdash; configure calendar entirely from Java backend</p>
					<p waBody="s" waColorText="quiet" waText>Automatic Jackson serialization for Angular binding</p>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-m">
					<div waCaption="s" waFontWeight="semibold" waText>EXAMPLES</div>
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>Calendar with Events</h4>
						<p waBody="s" waColorText="quiet" waText>Create a month-view calendar with drag-and-drop events.</p>
						<markdown [data]="mdContent_107" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
					</div>
				</div>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>QUICK START</div>
					<markdown [data]="mdContent_108" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-s">
					<div waCaption="s" waFontWeight="semibold" waText>SPI EXTENSION POINT DETAILS</div>
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="success">IPageConfigurator</wa-tag>
							<wa-tag pill variant="neutral">provides</wa-tag>
						</div>
						<p waBody="s" waColorText="quiet" waText>FullCalendarPageConfigurator auto-registers FullCalendar CSS/JS and Angular integration</p>
					</div>
				</div>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>SPI EXTENSION POINTS</div>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="success">provides IPageConfigurator</wa-tag>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>PREREQUISITES</div>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25 LTS</wa-tag>
						<wa-tag pill variant="neutral">Maven 3.9+</wa-tag>
						<wa-tag pill variant="neutral">Node.js 18+</wa-tag>
						<wa-tag pill variant="neutral">Angular 21+</wa-tag>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-cluster wa-gap-s">
					<wa-tag pill variant="neutral">Upstream: https://fullcalendar.io/</wa-tag>
					<wa-tag pill variant="neutral">Docs: https://fullcalendar.io/docs</wa-tag>
					<wa-tag pill variant="neutral">Source: https://github.com/JWebMP/FullCalendar</wa-tag>
				</div>
			</div>
		</wa-card>
	</div>
</div>